import React from 'react';

import "./Background.scss";


export const Background = () => {

    return (
        <section className="Background">
            <div className="logo">
                {/* <Img src={svgLogo}/> */}
            </div>
        </section>
    )
}

export default Background;
